import {Carousel} from "react-bootstrap";
import execs from "./Execs";

// function recruitment(){
//     const recrut_bg_style = {
//         padding: "5%", 
//         backgroundColor: "blue", 
//         backgroundImage: "linear-gradient(blue, black)"
//     };

//     const recrut = {src: recruitmentLogo, description: "Recruitment Fall 2021", link: "https://fb.me/e/TT8AlRhD", form:"https://docs.google.com/forms/d/e/1FAIpQLSf8DzjIAb1bLR_9zF2iY3IORCy9aV_GqRuVxmEoFKuPz036xQ/viewform"}
//     const styleRe = {
//         width: "70vw",
//         height: "auto",
//     };
//     return <div className="text-center">
//         {
//             <a href={recrut.link} target="_blank" rel="noreferrer"><img src={recrut.src} alt={recrut.description} style={styleRe} /></a>
//         }
//         <br/>
//         <Button variant="outline-info" size="lg" style={{marginTop: "3%"}} href={recrut.form} target="_blank">
//             <h3 style={{fontSize: "calc(2vw + 10px)"}}>Sign Me Up</h3>
//         </Button>
//     </div>;
// }

function display_execs(){
    return <div>
        <Carousel controls={false}>
            {execs.map(({src, description}) => <Carousel.Item interval={3500}><img src={src} alt={description} style={{display: "block", marginLeft: "auto", marginRight: "auto", width: "70vw", height: "auto"}}/><Carousel.Caption><h2>{description}</h2></Carousel.Caption></Carousel.Item>)}
        </Carousel>
    </div>;
}

function Member(){
    return <div id="fam" style={{padding: "5%", backgroundImage: "linear-gradient(rgb(251, 205, 38), rgb(247,151,98))"}}>
        <h1 style={{fontFamily: "Inter, sans-serif", fontSize: "calc(20px + 3vw)", textAlign: "center", color: "white"}}>Meet the Team!</h1>
        <br/>
        {display_execs()}
    </div>;
}

export default Member;